<mat-sidenav-container class="app-shell">

    <mat-sidenav #drawer mode="over" [opened]="false" class="bg-white">
        @defer (when drawer.opened) {
            <app-sidenav-content (closed)="drawer.close()" />
        }
    </mat-sidenav>

    <mat-sidenav-content class="h-full flex flex-col">
        <ng-content />
    </mat-sidenav-content>

</mat-sidenav-container>
